import React, { Dispatch, SetStateAction } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Switch from '../Switch/Switch';
import { LocalDataTrack } from 'twilio-video';
import './ToggleVideoEMDR.scss';

const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  padding: '0 1em',
});

export const Border = styled('div')({
  border: '2px solid linear-gradient(to bottom, #517EC5 35%, #F5F5F5 35%, #F5F5F5 100%)',
  borderRadius: '20px',
  background: 'linear-gradient(to bottom, #517EC5 35%, #F5F5F5 35%, #F5F5F5 100%)',
  padding: '0px',
});

interface TVEProps {
  t: any;
  isVideoEnabled: boolean;
  setVideoEnabled: Dispatch<SetStateAction<boolean>>;
  remoteDatatrack?: any;
  localDatatrack?: LocalDataTrack;
  isDisabled?: boolean;
}

interface TVEState {
  remoteDatatrack?: any;
  localDatatrack?: LocalDataTrack;
  setVideoEnabled: Dispatch<SetStateAction<boolean>>;
}

export default class ToggleVideoTask extends React.Component<TVEProps, TVEState> {
  constructor(props: any) {
    super(props);
    this.state = {
      remoteDatatrack: props.remoteDatatrack,
      localDatatrack: props.localDatatrack,
      setVideoEnabled: props.setVideoEnabled,
    };
  }

  toggleV(showV: boolean) {
    const { localDatatrack } = this.state;
    if (localDatatrack) {
      localDatatrack.send(
        JSON.stringify({
          type: 'VideoFrame Command',
          data: showV,
        })
      );
    }
    this.state.setVideoEnabled(showV);
  }

  toggleVideoEnabled(e: any) {
    this.toggleV(!this.props.isVideoEnabled);
  }

  onRight(e: any) {}

  render() {
    const { t, isVideoEnabled } = this.props;
    const tooltipVideo = t('Video');
    const tooltipTask = t('EMDR');

    return (
      <Tooltip title={isVideoEnabled ? tooltipVideo : tooltipTask} placement="top">
        <div className={'client-video-controls'}>
          <Border>
            <div className={'media-controls-options-container container-label'}>
              <h2>{t('client-scherm')}</h2>
            </div>
            <Container>
              <Switch
                isVideoEnabled={isVideoEnabled}
                name={'VideoTask'}
                onToggle={this.toggleVideoEnabled.bind(this)}
                onRight={this.onRight.bind(this)}
                isDisabled={this.props.isDisabled === undefined ? false : this.props.isDisabled}
              />
            </Container>
          </Border>
        </div>
      </Tooltip>
    );
  }
}
